interface SizeMessage {
  type: 'resize'
  height: number
}

interface DateMessage {
  type: 'set-date'
  date: string | null
}

type Message = SizeMessage | DateMessage

export function sendFrameMessage (message: Message): void {
  if (window.parent !== window) {
    window.parent.postMessage(message, '*')
  }
}
